import React, {useMemo} from 'react';

import {EEventSource} from 'coreClasses/events/IEvents';
import {useLocation, useProducts} from 'coreHooks';

import {VisibilityContextProvider} from 'brand/app/contexts/viewportProductContext';
import useViewItemListEvent from 'brandHooks/useViewItemListEvent';

import {ICarouselModuleBodyProps} from './ICarouselModuleBody';

const CarouselModuleBody = ({body, productIds}: ICarouselModuleBodyProps) => {
	const products = useProducts(productIds, true);
	const location = useLocation();
	const isHomepage = location?.isHomePage;
	const {handleProductVisibility} = useViewItemListEvent(
		products,
		isHomepage ? EEventSource.HOME : EEventSource.CONTENTFUL_CATEGORY,
	);

	const visibilityContextValue = useMemo(
		() => ({
			handleVisibilityChange: handleProductVisibility,
		}),
		[handleProductVisibility],
	);

	return <VisibilityContextProvider value={visibilityContextValue}>{body}</VisibilityContextProvider>;
};

export default CarouselModuleBody;
